<template>
  <div class="contact-main">
    <div class="content" id="content">
<!--      <div class="title">总部大楼</div>-->
<!--      <div-->
<!--        class="content-list"-->
<!--        v-for="(item, index) in contactList"-->
<!--        :key="index"-->
<!--      >-->
<!--          <div class="list-item">-->
<!--            <img :src="item.imgUrl" class="list-image" alt="" />-->
<!--            <div class="list-describe">{{item.describe}}</div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "building",
  data() {
    return {
        detail:{}
    };
  },
  created() {
    this.initData();
  },
  methods:{
      async initData() {
          const id = this.$route.query.id;
          console.log("id", id);

          let contents = await this.$getContents(this.$channels.staffLife);
          let list = [];
          await contents.filter(item => item.title == '总部大楼').forEach(
              item => {
                  list.push({
                      detail: item.body.replaceAll("/upload/images", process.env.VUE_APP_BASE_API + "/upload/images"),
                  })
              }
          );

          console.log("list", list);
          this.detail = list[0];
          console.log("robotData", this.detail)

          await this.$wrapDiv(this.detail.detail);
      }
  }
};
</script>
<style  scoped>
.contact-banner {
  width: 100%;
}
.content {
  margin-left: 48px;
  margin-right: 48px;

}
.content .title {
  font-size: 48px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  line-height: 68px;
}
.list-item {
  margin-top: 32px;
}

.list-image {
  width: 100%;
  margin-bottom: 4px;
}
.list-describe{
  font-size: 28px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: center;
  color: #666666;
  line-height: 56px;
}
.list-meta {
  position: absolute;
  left: 60px;
  bottom: 60px;
  display: flex;
  align-items: center;
}
.meta-title {
  font-size: 42px;
  font-family: PingFangSC, PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  color: #ffffff;
  line-height: 48px;
}
.list-meta .jump-arrow {
  width: 36px;
  height: 36px;
}
</style>
